import {Space} from "antd";
import {ProductCheckoutFormGroups} from "../../accordion/data";
import {OfferingFormAccordionItem} from "../../accordion/accordion-item";
import {ProductCheckoutFormFieldsProps} from "./types";

export function ProductCheckoutFormFields({
  isBookingQuestionsError,
}: ProductCheckoutFormFieldsProps) {
  return (
    <Space direction="vertical" size={16} style={{display: "flex"}}>
      {ProductCheckoutFormGroups.map((fg, index) => {
        if (fg.title === "Checkout form") {
          return (
            <OfferingFormAccordionItem
              key={fg.title}
              index={index}
              title={fg.title}
              isError={isBookingQuestionsError}
            >
              {fg.children}
            </OfferingFormAccordionItem>
          );
        } else {
          return null;
        }
      })}
    </Space>
  );
}
